import { Weapon } from "./weapon"

export abstract class SecondaryWeapon extends Weapon {
    destroy() {
        
    }
}
